import { BaseLogo } from "../../../core/models/entities/BaseLogo";
import { BoxHeaderTypography } from "../Typographies/BoxHeaderTypography";
import React from "react";
import { useTranslation } from "react-i18next";
import { Design } from "../../../core/models/entities/Design";
import { Order } from "../../../core/models/entities/Order";

export function LogoTitleHeader({ logo }: { logo: BaseLogo }) {
  const { t } = useTranslation();
  const sku = logo.product?.sku ?? "";
  const isUploadSku = sku.startsWith("UPLOAD_");

  return (
    <BoxHeaderTypography>
      {t("logo")} -{" "}
      <span className={"font-medium normal-case"}>
        {isUploadSku ? logo.title : `${sku} (${logo.title})`}
      </span>
    </BoxHeaderTypography>
  );
}

export function DesignTitleHeader({ design }: { design: Design }) {
  const { t } = useTranslation();
  return (
    <BoxHeaderTypography>
      {t("design")} -{" "}
      <span className={"font-medium normal-case"}>
        {design.product?.mul ?? t("compLogoDesign.noMul")} ({design.title})
      </span>
    </BoxHeaderTypography>
  );
}

export function OrderTitleHeader({ order }: { order: Order }) {
  const { t } = useTranslation();
  return (
    <BoxHeaderTypography>
      {t("order")} -{" "}
      <span className={"font-medium normal-case"}>
        {order.id ?? t("compLogoDesign.noId")} ({order.id})
      </span>
    </BoxHeaderTypography>
  );
}
